import { render, staticRenderFns } from "./EditDefectRequestStatus.vue?vue&type=template&id=c6e25668&"
import script from "./EditDefectRequestStatus.vue?vue&type=script&lang=js&"
export * from "./EditDefectRequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditDefectRequestStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports